import {
  AbsolutesBlackColors,
  AbsolutesWhiteColors,
  NegativeColors,
  PositiveColors,
  PrimaryColors,
} from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

// import { BreakPoints } from '@picsart/design-system/foundation/responsive';
import { ColorSchemeType } from 'redesignedComponents/context/colorScheme';
import { ColorSchemes } from 'redesignedComponents/context/colorScheme/enums';

type StyleProps = {
  colorScheme?: ColorSchemeType;
};

const useStyles = createUseStyles<string, { colorScheme?: 'light' | 'dark' }>(
  () => ({
    root: {
      padding: [Spacings.s72, 142],
      background: (prop: StyleProps) =>
        prop?.colorScheme === ColorSchemes.DARK
          ? AbsolutesBlackColors.base.default
          : AbsolutesWhiteColors.base.default,
      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        padding: Spacings.s0,
        overflow: 'hidden',
      },
    },
    title: {
      maxWidth: 676,
      textAlign: 'center',
      fontSize: FontSizes.s42,
      lineHeight: LineHeights.l50,
      fontWeight: FontWeights.semibold,
      color: (prop: StyleProps) =>
        prop?.colorScheme === ColorSchemes.DARK
          ? NegativeColors.text.default
          : PositiveColors.text.default,
      margin: [Spacings.s0, 'auto', Spacings.s24, 'auto'],
      '@media screen and (max-width: 766px)': {
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l28,
        padding: [Spacings.s0, Spacings.s24],
      },
    },
    titleFallback: {
      width: '60%',
      height: 40,
      margin: [Spacings.s0, 'auto', Spacings.s12, 'auto'],

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        height: 28,
      },
      '&.short': {
        width: '30%',
      },
    },
    ratioWrapper: {
      height: 440,
      '@media screen and (max-width: 768px)': {
        height: 'initial',
      },
    },
    description: {
      width: '100%',
      maxWidth: 768,
      margin: 'auto',
      marginBottom: Spacings.s24,
      textAlign: 'center',
      fontSize: FontSizes.s20,
      lineHeight: LineHeights.l28,
      color: (prop: StyleProps) =>
        prop?.colorScheme === ColorSchemes.DARK
          ? NegativeColors.text.default
          : PositiveColors.text.default,
      '@media screen and (max-width: 768px)': {
        lineHeight: LineHeights.l20,
        marginBottom: Spacings.s32,
        padding: [Spacings.s0, Spacings.s24],
      },
      '& p': {
        fontWeight: FontWeights.medium,
      },
    },
    tabDescription: {
      marginBottom: Spacings.s48,
    },
    descriptionFallback: {
      width: '80%',
      height: 26,
      margin: [Spacings.s0, 'auto', Spacings.s6, 'auto'],

      '&.short': {
        width: '40%',
      },
    },
    customTabsWrapper: {
      '& div[class*=wrapper]': {
        justifyContent: 'start',
        gap: 8,
      },
      '&&': {
        background: (prop: StyleProps) =>
          prop?.colorScheme === ColorSchemes.DARK
            ? AbsolutesBlackColors.base.default
            : AbsolutesWhiteColors.base.default,
        border: `2px solid`,
        borderColor: (prop: StyleProps) =>
          prop?.colorScheme === ColorSchemes.DARK ? '#616161' : '#E0E0E0',
        padding: [Spacings.s8, Spacings.s12],
        '@media screen and (max-width: 768px)': {
          marginLeft: Spacings.s24,
        },
      },

      '& > div': {
        background: (prop: StyleProps) =>
          prop?.colorScheme === ColorSchemes.DARK
            ? AbsolutesBlackColors.base.default
            : AbsolutesWhiteColors.base.default,
      },

      '& button': {
        height: 40,
        padding: [Spacings.s10, Spacings.s12],
        '@media screen and (max-width: 768px)': {
          padding: [Spacings.s6, Spacings.s12],
        },
        color: (prop: StyleProps) =>
          prop?.colorScheme === ColorSchemes.DARK
            ? AbsolutesWhiteColors.base.default
            : AbsolutesBlackColors.base.default,
      },
      '& button[class$="selectedToogle"]': {
        backgroundColor: PrimaryColors.base.default,
        color: AbsolutesWhiteColors.base.default,
      },
    },

    togglesHolder: {
      marginBottom: Spacings.s32,
    },
    togglesFallback: {
      width: 380,
      height: 40,
      borderRadius: CornerRadius.r24,
      margin: [Spacings.s32, 'auto', Spacings.s0, 'auto'],
    },
    imgHolder: {
      maxWidth: 872,
      padding: [Spacings.s0, Spacings.s0, Spacings.s6],
      margin: 'auto',
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 768px)': {
        padding: Spacings.s24,
        paddingTop: Spacings.s0,
      },
    },
    img: {
      margin: 'auto',
      '& img': {
        borderRadius: CornerRadius.r24,
        maxHeight: 440,
        objectFit: 'fill',
        margin: 'auto',
        '@media screen and (max-width: 768px)': {
          maxHeight: 250,
        },
      },
    },
    imgFallback: {
      width: '100%',
      height: 374,
    },
  }),
  {
    name: 'use-case-with-toggle',
  },
);

export default useStyles;
